var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-main has-bottom" },
        [
          _c("page-title"),
          _vm._v(" "),
          _c(
            "page-card",
            { staticStyle: { "margin-bottom": "32px" } },
            [
              _c("template", { slot: "header" }, [
                _vm._v("\n        Producer Information\n      "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("base-info", {
                    attrs: { "page-data": _vm.pageData },
                    on: {
                      "update:pageData": function ($event) {
                        _vm.pageData = $event
                      },
                      "update:page-data": function ($event) {
                        _vm.pageData = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-header" }, [
                    _vm._v("\n          Well Information\n        "),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.reviewList, function (group, index) {
                    return _c("pointComp", {
                      key: "group" + index,
                      ref: "pointComp",
                      refInFor: true,
                      attrs: {
                        "page-data": group,
                        "point-index": index,
                        "annual-review": true,
                      },
                    })
                  }),
                ],
                2
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "page-bottom",
        [
          [
            _c(
              "div",
              { staticClass: "page-btns" },
              [
                _c("loading-btn", {
                  attrs: { type: "primary", label: "Submit" },
                  on: { clickHandle: _vm.submit },
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c("editInformationSuccess", {
        ref: "editInformationSuccess",
        on: { close: _vm.closeSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }